import { postApiV1SearchSuggestions } from '@/open-api/search-suggestions/search-suggestions';
import { logEvent } from '@/pages/api/v1/utils';
import { ASSET_TYPE, type AssetType } from '@/types/asset';
import {
  addHubSpotEvent,
  HUBSPOT_EVENTS,
} from '@/utils/analytics/hubspot/add-hubspot-event';

const VALID_ASSET_TYPES = new Set<string>(Object.values(ASSET_TYPE));

function sanitizePath(path: string) {
  try {
    const searchParamWhitelist = ['type', 'query'];

    const url = new URL(path, 'https://temp');

    url.searchParams.forEach((_value, key) => {
      if (!searchParamWhitelist.includes(key)) {
        url.searchParams.delete(key);
      }
    });

    return `${url.pathname}${url.search}`;
  } catch {
    return path;
  }
}

export async function logSearch(
  searchTerm: string,
  pageCurrent: string,
  pageNext: string,
  actionType: string,
  assetType?: string
): Promise<void> {
  void logEvent({
    event_type: 'search',
    asPath: pageCurrent,
    metadata: {
      type: actionType,
      text: searchTerm,
      next_path: pageNext,
      ...(assetType &&
        VALID_ASSET_TYPES.has(assetType) && {
          asset_type: assetType as AssetType,
        }),
    },
  });

  if (searchTerm) {
    addHubSpotEvent(HUBSPOT_EVENTS.usedSearch, {
      search_term: searchTerm,
      asset_type: assetType,
    });
  }

  // The API only records complete searches (e.g. not trending clicks with no
  // term), so don't send the rest.
  if (!(searchTerm && pageCurrent && pageNext && actionType)) {
    return;
  }

  try {
    await postApiV1SearchSuggestions({
      searchTerm,
      pageCurrent: sanitizePath(pageCurrent),
      pageNext,
      actionType,
    });
  } catch {
    // Best effort: a failed record must not break the search.
  }
}
